import {VacationDateRangeFilter, VacationPropertyFilter, VacationReportItem} from './types';
import {store} from '../../store/store';
import vacationsReportReducer, {setData, updateDateRangeFilter, updatePropertyFilter} from './reportSlice';

export const updateVacationReportPropertyFilter = (filter: VacationPropertyFilter) => {
    store.dispatch(updatePropertyFilter(filter));
}

export const updateVacationReportDateRangeFilter = (filter: VacationDateRangeFilter) => {
    store.dispatch(updateDateRangeFilter(filter));
}

export const setVacationReportData = (data: Array<VacationReportItem>) => {
    store.dispatch(setData(data))
}

export { vacationsReportReducer };